export default function flySureTravelCompanyNames() {
  return [
    'Aer Lingus',
    'Aerospace Construction',
    'Air Canada',
    'Air France',
    'Air France - KLM',
    'Air New Zealand',
    'Airline (unlisted)',
    'Airline Maintenance',
    'Airline Support',
    'Airport Based Worker ',
    'Alitalia',
    'All Nippon Airways',
    'American Airlines',
    'Aviation (Airport) Security',
    'BA CityFlyer',
    'BMI',
    'British Airways ',
    'Cathay Pacific',
    'Civil Aviation Authority',
    'Cobalt Ground Solutions',
    'Delta Airlines (Delta)',
    'DHL',
    'EasyJet',
    'Emirates',
    'Etihad Airways',
    'Flag Carrier (National) Airline',
    'Flybe',
    'Gatwick Airport',
    'Heathrow Airport',
    'Helicopter Construction and Maintenance',
    'KLM',
    'Lufthansa ',
    'Not listed',
    'Other',
    'Ryanair',
    'Singapore Airlines',
    'Thomas Cook Airlines',
    'Travel Services (Unlisted)',
    'TUI Airways / Thompson',
    'United Airlines',
    'Virgin Atlantic',
  ];
}
